import React from 'react';
import {} from 'components/core';
import TemplatesList from './list';
import EditWizard from './editWizard';


export default function TemplatesMain({mainDialogOpen, onDialogClose, collapsed, handleShowPanel, setLoadedProcedure})
{
    const [editDialogState, setEditDialogState] = React.useState({open: false, templateID: null});

    React.useEffect(() => {
      if(mainDialogOpen) setEditDialogState({open: true, templateID: null});
    }, [mainDialogOpen]);

    const handleRowSelected = (row) =>
    {
      // handleShowPanel({templateID: row.id});
    }

    const handleOpenEdit = (openID) =>
    {
      setEditDialogState({open: true, templateID: openID});
      // handleShowPanel({templateID: openID});
    }

    const handleCloseEdit = () => {
      setEditDialogState({open: false, templateID: null});
      if(onDialogClose) onDialogClose();
    }

    return <>
      <EditWizard open={editDialogState.open} onClose={()=>handleCloseEdit()} templateID={editDialogState.templateID}/>
      <TemplatesList onRowSelected={(row) => handleRowSelected(row)} collapsed={collapsed} onEdit={(templateID) => handleOpenEdit(templateID)} />
    </>
}

